import React from "react";
import Footer from "../../components/Footer";
import NavLite from "../../components/NavLite";


function ToolsWeUse() {
  <main>
  <title>Tools of the Trade | SEO & Design Tools We Trust | Her Growth Co.</title>
<meta
name="description"
content="See the expert tools and platforms we use to deliver high-performance SEO and web design for women-led businesses."
/>
<meta
name="keywords"
content="tech stack for women-led businesses, tools for digital growth, software for brand building, SEO tools for consultants, design tools for founders, expert tools for website visibility, recommended platforms for scaling"
/>
</main>
  return (
    <div>
<NavLite/>
      <div className="text-center items-center justify-center text-9xl mt-10">
        Coming Soon
        </div>
        <Footer />
     
    </div>
  );
}

export default ToolsWeUse